<template>
	<div class="card card-body border-0 wrapper-box p-0 text-center mb-4 product-container position-relative">
		<div class="product-img" :class="{ 'blur': isProductPrivate }" @click="login">
			<img :src="dummyProduct.image" :alt="'Product'" v-if="!isLoading" class="cursor-pointer" />
			<shimmer v-else width="250px" height="180px" />
		</div>
		<div class="product-detail-container" :class="{ 'blur': isProductPrivate }">
			<div class="product-name cursor-pointer">
				<span v-if="!isLoading">{{ dummyProduct.name }}</span>
				<shimmer v-else height="30px" />
			</div>
			<badges :is-cod-enabled="isCODEnabled" v-if="!isLoading"></badges>
			<div v-else class="text-left">
				<shimmer width="25px" height="17px" />
			</div>
			<div class="product-detail text-left mt-2">
				<div class="product-price-detail">
					<div v-if="!isLoading" class="capital">
						<span class="label" v-if="!isLoading">Harga Modal : </span>
						<span class="price" v-if="!isLoading">{{ dummyProduct.buyPrice }}</span>
					</div>
					<shimmer v-else height="10px" />
					<div v-if="!isLoading" class="selling">
						<span class="label label-sm" v-if="!isLoading">Rekomendasi Harga Jual : </span>
						<span class="price" v-if="!isLoading">{{ dummyProduct.sellPrice }}</span>
					</div>
					<shimmer v-else width="100px" height="10px" />
				</div>
				<div class="location-stock row m-0 mt-2">
					<div class="location col-6 p-0">
						<div class="d-flex" v-if="!isLoading">
							<span class="map-icon pr-1"><i class="bi bi-geo-alt-fill"></i></span>
							<span class="label" v-if="!isLoading">{{ dummyProduct.origin }}</span>
						</div>
						<shimmer v-else width="50px" height="10px" />
					</div>
					<div class="stock col-6 text-right p-0">
						<div v-if="!isLoading">
							<span class="label pr-1">Stok :</span>
							<span class="total" v-if="!isLoading">{{ dummyProduct.stock }}</span>
						</div>
						<shimmer v-else width="50px" height="10px" />
					</div>
				</div>
			</div>
			<div class="product-detail-button">
				<template v-if="!isLoading">
					<button class="btn-outline o-sm outline-primary w-100" :disabled="isDisabled" @click="login">
						<span v-if="!isHaveOrderValidation">
							{{ $t('Unable to display products, click to see terms & conditions') }}
						</span>
						<span v-else>
							{{ $t('Login to view product') }}
						</span>
					</button>
				</template>
				<shimmer v-else :maxWidth="100" :height="'40px'" />
			</div>
		</div>
		<a :href="isProductPrivate ? (!isUser ? '/login' : 'https://help.ostock.id/id/articles/8894069-ketentuan-melihat-produk-terlaris') : '/login'">
			<overlay v-if="isProductPrivate">
				<span v-if="!isHaveOrderValidation && isUser">
					{{ $t('Unable to display products, click to see terms & conditions') }}
				</span>
				<span v-else>
					<span class="text-decoration-none">
						{{ $t('Login to view product') }}
					</span>
				</span>
			</overlay>
		</a>
		<!-- Notifications -->
		<notifications group="dropship" position="bottom right"></notifications>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Shimmer from '@/components/Shimmer.vue';
import Overlay from '@/components/homepages/sections/partials/Overlay.vue';
import Badges from '@/components/products/Badges.vue';

export default {
	name: 'ProductDummy',
	components: {
		Shimmer,
		Overlay,
		Badges,
	},
	props: {
		product: {
			type: Object,
			default: null,
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
		isHaveOrder: {
			type: Boolean,
			default: true,
		},
		isUser: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			dummyProduct: {
				name: 'Product Name',
				buyPrice: 'RpXX.000',
				sellPrice: 'RpXXX.000',
				stock: '999',
				origin: 'WH Ostock',
				image: 'https://cdn.ostock.id/img/default-product.png',
			},
		};
	},
	methods: {
		login() {
			this.$router.push('/login');
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		isProductPrivate() {
			return true;
		},
		isDisabled() {
			return this.isProductPrivate;
		},
		isCODEnabled() {
			return true;
		},
		isHaveOrderValidation() {
			return this.isHaveOrder;
		},
		isUserValidation() {
			return this.isUser;
		},
	},
};
</script>
<style lang="scss" scoped>
.wrapper-box {
	max-width: 306px;
	border-radius: 5px;
}

.product-img {
	padding: 0 !important;
	height: auto !important;
	border-top-left-radius: 5px;
	border-top-right-radius: 5px;
	overflow: hidden;

	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;

	img {
		position: relative !important;

		width: 100%;
		flex-shrink: 0;
		min-width: 100%;
		min-height: 100%;
		max-width: 100%;
		object-fit: cover;
		top: 0;
		bottom: 0;
		margin: auto;
		transition: 0.3s all cubic-bezier(0.45, 0.05, 0.55, 0.95);
		height: 200px;

		@media screen and (max-width: 540px) {
			max-height: 155px;
		}
	}
}

.product-detail-container {
	padding: 16px;

	.product-name {
		font-weight: 700;
		font-size: 14px;
		color: #4D4D4D;
		display: -webkit-box;
		max-width: 400px;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		height: 45px;
	}

	.product-detail {
		font-size: 12px;
		color: #616672;

		.product-price-detail {
			.capital {
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				font-size: 14px;
				font-weight: 600;

				.price {
					color: #ff9f1a;
				}

				@media (max-width: 575px) {
					font-size: 10px;
				}
			}

			.selling {
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;

				.price {
					color: #2B2F39;
				}

				@media (max-width: 575px) {
					font-size: 9px;
				}
			}
		}

		.location-stock {
			.location {
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}
	}

	.product-detail-button {
		margin-top: 12px;

		.btn-outline {
			@media screen and (max-width: 540px) {
				font-size: 15px;
			}
		}

		.dropdown {
			.dropdown-menu {
				border-radius: 8px;

				.dropdown-item {
					font-size: 13px;

					@media screen and (max-width: 540px) {
						font-size: 12px;
					}
				}
			}
		}
	}
}

@keyframes slide-up {
	0% {
		opacity: 0;
		transform: translateY(100%)
	}

	100% {
		opacity: 1;
		transform: translateY(0)
	}
}

@keyframes slide-down {
	0% {
		opacity: 0;
		transform: translateY(-100%)
	}

	100% {
		opacity: 1;
		transform: translateY(0)
	}
}

.origin {
	display: none;
}

.product-container:hover .origin {
	display: block;
	-webkit-animation: slide-up .3s ease-out;
	-moz-animation: slide-up .3s ease-out;
}

.product-container:hover .warehouse-label {
	display: none;
}

.product-container:not(:hover) .warehouse-label {
	display: block;
	-webkit-animation: slide-down .3s ease-out;
	-moz-animation: slide-down .3s ease-out;
}

.blur {
	border-radius: 5px;
	filter: blur(3px);
}

.label-sm {
	font-size: 11px !important;

	@media (max-width: 575px) {
		font-size: 8px !important;
	}
}
.text-decoration-none {
	text-decoration: none;
	color: white;
}
</style>
